module.exports = __webpack_public_path__ + "static/Fan Wear Screen 2-dc17897ed1ed1fb6e263db741dfac817.png";